import { render, staticRenderFns } from "./Lamp.vue?vue&type=template&id=6758e1b2&scoped=true"
import script from "./Lamp.vue?vue&type=script&lang=js"
export * from "./Lamp.vue?vue&type=script&lang=js"
import style0 from "./Lamp.vue?vue&type=style&index=0&id=6758e1b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6758e1b2",
  null
  
)

export default component.exports